import React from 'react';
import { Input } from 'antd';
import { FormItem, Subtitle } from '../styles';
import styled from 'styled-components';

const PhoneInputWrapper = styled.div`
  margin: 8px 0 16px 0;

  @media (max-width: 480px) {
    margin: 6px 0 12px 0;
  }

  @media (max-width: 360px) {
    margin: 4px 0 10px 0;
  }
`;

const StyledInput = styled(Input)`
  text-align: center !important;
  font-size: 16px !important;
  font-weight: 600 !important;
  border-radius: 10px !important;
  padding: 12px 16px !important;
  height: auto !important;
  background-color: ${({ theme }) => (theme.mode === 'dark' ? 'rgba(255, 255, 255, 0.05)' : '#f7fafc')} !important;
  border: 1px solid ${({ theme }) => (theme.mode === 'dark' ? 'rgba(255, 255, 255, 0.1)' : '#e2e8f0')} !important;
  color: ${({ theme }) => (theme.mode === 'dark' ? '#f7fafc' : '#1a202c')} !important;
  letter-spacing: 1px;

  &:focus {
    border-color: #2D6CCA !important;
    box-shadow: 0 0 0 3px rgba(45, 108, 202, 0.1) !important;
  }

  @media (max-width: 480px) {
    font-size: 14px !important;
    padding: 10px 14px !important;
    border-radius: 8px !important;
  }

  @media (max-width: 360px) {
    font-size: 13px !important;
    padding: 8px 12px !important;
  }
`;

const PhoneLabel = styled(Subtitle)`
  margin-bottom: 6px !important;
  font-weight: 500 !important;

  @media (max-width: 480px) {
    margin-bottom: 4px !important;
  }
`;

interface PhoneDisplayProps {
  phone: string;
}

const PhoneDisplay: React.FC<PhoneDisplayProps> = ({ phone }) => {
  return (
    <FormItem>
      <PhoneInputWrapper>
        <PhoneLabel>We've sent a code to:</PhoneLabel>
        <StyledInput
          value={`${'*'.repeat(Math.max(0, phone?.length - 4))}${phone?.slice(-4) || ''}`}
          readOnly
        />
      </PhoneInputWrapper>
    </FormItem>
  );
};

export default PhoneDisplay;
